import { ArticleOutlined } from '@mui/icons-material'
import {
  Card,
  CardActionArea,
  CardContent,
  Link,
  styled,
  Typography
} from '@mui/material'

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(1),
  color: theme.palette.primarySoft.main
}))

const StyledCardActionArea = styled(CardActionArea)(({ theme }) => ({
  height: '100%',
  '&[data-active]': {
    backgroundColor: 'action.selected',
    '&:hover': {
      backgroundColor: 'action.selectedHover'
    }
  }
}))

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  height: '100%'
}))

/**
 * IReferenceProps interface that defines the props for the Reference component.
 */
interface IReferenceProps {
  /** The link to the reference */
  link: string
  /** The title of the reference */
  title: string
}

/**
 * Reference component for displaying a link with a title.
 * @param {IReferenceProps} props - The properties for the Reference component.
 * @returns {JSX.Element} The rendered Reference component.
 * @example
 * <Reference link="https://example.com" title="Example Reference" />
 */
export const Reference: React.FC<IReferenceProps> = ({ link, title }) => {
  return (
    <Link href={link} target='_blank' style={{ textDecoration: 'none' }}>
      <StyledCard>
        <StyledCardActionArea>
          <StyledCardContent>
            <ArticleOutlined fontSize='large' />
            <Typography
              variant='subtitle2'
              fontWeight='bold'
              component='div'
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                wordBreak: 'break-word'
              }}
            >
              {title}
            </Typography>
          </StyledCardContent>
        </StyledCardActionArea>
      </StyledCard>
    </Link>
  )
}

export default Reference
